// extracted by mini-css-extract-plugin
export default {"container":"ModalUploadPicture_container__M4Jyi","upload-photo":"ModalUploadPicture_upload-photo__y2O5J","disabled":"ModalUploadPicture_disabled__wBE3w"};